// extracted by mini-css-extract-plugin
export var button = "styles-module--button--rOzxn";
export var choice = "styles-module--choice--tNgIf";